module.exports = __webpack_public_path__ + "e457bfa661bd3991540cc5f0aeb53837.gif";